import Fetch, { FetchPublic } from './index';

const BASE_PATH = '/agent-build-request';

export async function submitAgentBuildRequest(metadata, files, idempotencyKey) {
  const formData = new FormData();
  formData.append('metadata', JSON.stringify(metadata));
  files.forEach(({ file }) => formData.append('files', file));
  return FetchPublic(`${BASE_PATH}/public`, {
    method: 'POST',
    body: formData,
    headers: { 'Idempotency-Key': idempotencyKey },
  });
}

export function getAgentBuildRequestPublicConfig() {
  return FetchPublic(`${BASE_PATH}/public/config`);
}

export function createAgentBuildRequestCheckout(trackingId) {
  return FetchPublic(`${BASE_PATH}/public/${encodeURIComponent(trackingId)}/checkout`, { method: 'POST' });
}

export function chooseFreeAgentBuildRequest(trackingId) {
  return FetchPublic(`${BASE_PATH}/public/${encodeURIComponent(trackingId)}/choose-free`, { method: 'POST' });
}

export function listAgentBuildRequests(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, value);
  });
  return Fetch(`${BASE_PATH}?${query.toString()}`);
}

export function getAgentBuildRequest(id) {
  return Fetch(`${BASE_PATH}/${id}`);
}

export function getAgentBuildRequestSettings() {
  return Fetch(`${BASE_PATH}/settings`);
}

export function updateAgentBuildRequestSettings(payload) {
  return Fetch(`${BASE_PATH}/settings`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function getPublicAgentBuildRequest(trackingId) {
  return FetchPublic(`${BASE_PATH}/public/${encodeURIComponent(trackingId)}`);
}

export function updateAgentBuildRequest(id, payload) {
  return Fetch(`${BASE_PATH}/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function retryAgentBuildRequestNotification(requestId, notificationId) {
  return Fetch(`${BASE_PATH}/${requestId}/notifications/${notificationId}/retry`, {
    method: 'POST',
  });
}

export async function downloadAgentBuildRequestAttachment(requestId, attachmentId) {
  const response = await fetch(`${import.meta.env.VITE_SERVICE}${BASE_PATH}/${requestId}/attachment/${attachmentId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || body.errorMessage || 'Não foi possível carregar o anexo.');
  }
  return response.blob();
}
